import React from 'react'
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { Title } from "react-admin"
import BarChartIcon from "@mui/icons-material/BarChart"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Box } from '@mui/material'
import { AuditTable, FieldConfig } from 'components/audit'

const TabList = () => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
        <Box display="flex" flexDirection="column" width="100%">
           <RecordActionsTabs subTabs={subTabs} resourceParent="devices"/>
        </Box>
    )
}

// Пример использования компонента AuditTable на отдельной странице
export const DeviceAuditHistoryPage = () => {
  const { id } = useParams<{ id: string }>()
  const translate = useTranslate()
  const deviceConfigs: FieldConfig[] = [
    { field: 'imei', label: translate("resources.devices.fields.imei"), visible: true },
    { field: 'device_kind_id', label: translate("resources.devices.fields.device_kind_id"), visible: true },
    { field: 'iccid', label: translate("resources.devices.fields.iccid"), visible: true },
    { field: 'phone', label: translate("resources.devices.fields.phone"), visible: true },
    { field: 'equipment_ids[0]', label: translate("resources.devices.fields.equipment_ids")+" 1", visible: true },
    { field: 'equipment_serial_numbers[0]', label: translate("resources.devices.fields.equipment_serial_numbers")+" 1", visible: true },
    { field: 'equipment_ids[1]', label: translate("resources.devices.fields.equipment_ids")+" 2", visible: true },
    { field: 'equipment_serial_numbers[1]', label: translate("resources.devices.fields.equipment_serial_numbers")+" 2", visible: true },
    { field: 'equipment_ids[2]', label: translate("resources.devices.fields.equipment_id_bbt"), visible: true },
    { field: 'equipment_serial_numbers[2]', label: translate("resources.devices.fields.equipment_serial_number_bbt"), visible: true },
    { field: 'energy_kind_id', label: translate("resources.devices.fields.energy_kind_id"), visible: true },
    { field: 'object_id', label: translate("resources.devices.fields.object_id"), visible: true },
    //{ field: 'name', label: translate("resources.common.fields.name"), visible: true },
    { field: 'description', label: translate("resources.common.fields.description"), visible: true },

  ]


  return (
     <>
        <Title title={translate('internal.audit')}/>
        <TabList />
        <AuditTable 
          tableName="devices"
          recordId={id!}
          showUserColumn={true}
          dense={false}
          className="audit-history-table"
          fieldConfigs={deviceConfigs}
        />
     </>
  )
}

export default DeviceAuditHistoryPage
